import { Pagination as PaginationBar } from 'antd';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import {
	ApplicationSummary,
	ApplicationSummaryList,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { CTDApplicationSummaryCard } from './CTDApplicationSummaryCard';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';
import { CTDApplicationSummaryTable } from './CTDApplicationSummaryTable';
import EmptyList from '../../../components/EmptyList';

export const CTDApplicationsList = ({
	data: { applicationSummary: applications, pagination },
	onPageChange,
	onEvaluateClick,
	pageConfig,
}: {
	data: ApplicationSummaryList;
	onPageChange: (page: number, pageSize: number) => void;
	onEvaluateClick: (application: ApplicationSummary) => void;
	pageConfig: PagingConfig;
}) => {
	const { t } = useTranslation();
	if (
		isEmpty(pagination.totalNoOfRecords) ||
		pagination.totalNoOfRecords === 0
	) {
		return <EmptyList message={t('noApplications')} />;
	}

	const ctdApplicationCards = applications?.map((application) => (
		<div className="mb-[16px]" key={application.applicationId}>
			<CTDApplicationSummaryCard
				{...application}
				onEvaluateClick={onEvaluateClick}
			/>{' '}
		</div>
	));

	return (
		<div className="flex flex-col gap-6">
			<div className="sm:hidden">
				{ctdApplicationCards}
				<div className="flex justify-center w-full">
					<PaginationBar
						current={pageConfig.pageNo ?? 1}
						total={pagination.totalNoOfRecords}
						defaultPageSize={pageConfig.pageSize ?? DEFAULT_PAGE_SIZE}
						onChange={onPageChange}
					/>
				</div>
			</div>
			<div className="hidden sm:block px-4">
				<div className="border rounded-xl shadow-sm bg-white">
					<CTDApplicationSummaryTable
						applications={applications}
						onEvaluateClick={onEvaluateClick}
						pagination={pagination}
						onPageChange={onPageChange}
						pageConfig={pageConfig}
					/>
				</div>
			</div>
		</div>
	);
};
